import { useIntl } from 'react-intl';
import { cx, Typography } from '@bolteu/clay-react';

import { TIER_META } from '../consts';
import { DisplayTier } from '../types';

const SIZE_CLASSES = {
  medium: { gap: 'gap-0.5', icon: 'h-6', text: 'bolt-font-heading-xs-accent' },
  large: { gap: 'gap-1.25', icon: 'h-9', text: 'bolt-font-heading-l-accent' },
  xlarge: { gap: 'gap-1.25', icon: 'h-13', text: 'bolt-font-display-m-regular font-semibold' },
  responsive: {
    gap: 'gap-0.5 sm:gap-1.25',
    icon: 'h-6 sm:h-9',
    text: 'bolt-font-heading-xs-accent sm:bolt-font-heading-l-accent',
  },
};

export interface TierMedalProps<T extends DisplayTier> {
  tier: T;
  size: keyof typeof SIZE_CLASSES;
  tierLabelKeys: Record<T, string>;
  labelClassName?: string;
}

export function TierMedal<T extends DisplayTier>({
  tier,
  size,
  tierLabelKeys,
  labelClassName,
}: TierMedalProps<T>) {
  const intl = useIntl();
  const tierMeta: (typeof TIER_META)[DisplayTier] | undefined = TIER_META[tier];
  const labelKey: string | undefined = tierLabelKeys[tier];

  if (!tierMeta || !labelKey) {
    return null;
  }

  const classes = SIZE_CLASSES[size];

  return (
    <span className={cx('flex flex-row items-center', classes.gap)}>
      {tierMeta.leftIcon ? <img src={tierMeta.leftIcon} alt="" className={classes.icon} /> : null}
      <Typography className={cx(classes.text, labelClassName)}>
        {intl.formatMessage({ id: labelKey })}
      </Typography>
      {tierMeta.rightIcon ? <img src={tierMeta.rightIcon} alt="" className={classes.icon} /> : null}
    </span>
  );
}
